const RECENT_API_ERROR_WINDOW_MS = 1200

let recentApiError: { message: string; shownAt: number } | null = null

export function rememberApiErrorMessage(message: string): void {
  const normalized = message.trim()
  if (!normalized) return
  recentApiError = {
    message: normalized,
    shownAt: Date.now()
  }
}

export function takeRecentApiErrorMessage(): string | null {
  if (!recentApiError) return null
  if (Date.now() - recentApiError.shownAt > RECENT_API_ERROR_WINDOW_MS) {
    recentApiError = null
    return null
  }

  const message = recentApiError.message
  recentApiError = null
  return message
}

export function clearRecentApiErrorMessage(): void {
  recentApiError = null
}
